export interface PatientConsentTranslations {
  loading: string;
  patientConsent: string;
  declineTerms: {
    dischargedWithin30Days: string;
    notDischargedWithin30Days: string;
    popup: {
      title: string;
      cancel: string;
      decline: string;
    },
  },
  acceptConsent: {
    acceptButton: {
      saving: string;
      next: string;
    },
  },
  acceptHipaa: {
    authority: {
      parent: string;
      legalGuardian: string;
      other: string;
      otherInput: {
        placeHolder: string;
      },
    },
    options: {
      agree: string;
      decline: string;
    },
    acceptButton: {
      saving: string;
      continue: string;
    },
  },
  errors: {
    loadingPatientConsentInfo: string;
    unexpectedErrorTryAgain: string;
    noPatientConsentInfoFound: string;
    noHipaaConsentInfoFound: string;
  },
}

export const patientConsentTranslationKeys: PatientConsentTranslations = {
  loading: 'loading',
  patientConsent: 'patientConsent',
  declineTerms: {
    dischargedWithin30Days: 'declineTerms.dischargedWithin30Days',
    notDischargedWithin30Days: 'declineTerms.notDischargedWithin30Days',
    popup: {
      title: 'declineTerms.popup.title',
      cancel: 'declineTerms.popup.cancel',
      decline: 'declineTerms.popup.decline',
    },
  },
  acceptConsent: {
    acceptButton: {
      saving: 'acceptConsent.acceptButton.saving',
      next: 'acceptConsent.acceptButton.next',
    },
  },
  acceptHipaa: {
    authority: {
      parent: 'acceptHipaa.authority.parent',
      legalGuardian: 'acceptHipaa.authority.legalGuardian',
      other: 'acceptHipaa.authority.other',
      otherInput: {
        placeHolder: 'acceptHipaa.authority.otherInput.placeHolder',
      },
    },
    options: {
      agree: 'acceptHipaa.options.agree',
      decline: 'acceptHipaa.options.decline',
    },
    acceptButton: {
      saving: 'acceptHipaa.acceptButton.saving',
      continue: 'acceptHipaa.acceptButton.continue',
    },
  },
  errors: {
    loadingPatientConsentInfo: 'errors.loadingPatientConsentInfo',
    unexpectedErrorTryAgain: 'errors.unexpectedErrorTryAgain',
    noPatientConsentInfoFound: 'errors.noPatientConsentInfoFound',
    noHipaaConsentInfoFound: 'errors.noHipaaConsentInfoFound',
  },
};

export const patientConsentTranslationsEN: PatientConsentTranslations = {
  loading: 'Loading...',
  patientConsent: 'Patient Consent',
  declineTerms: {
    dischargedWithin30Days: 'You will have another opportunity to accept or decline these terms at 30 days post-discharge.',
    notDischargedWithin30Days: 'You will not be able to use Reflections without accepting these terms.',
    popup: {
      title: 'Decline Terms?',
      cancel: 'Cancel',
      decline: 'Decline',
    },
  },
  acceptConsent: {
    acceptButton: {
      saving: 'Saving...',
      next: 'Next',
    },
  },
  acceptHipaa: {
    authority: {
      parent: 'Parent',
      legalGuardian: 'Legal Guardian',
      other: 'Other (describe authority)',
      otherInput: {
        placeHolder: 'Describe authority...',
      },
    },
    options: {
      agree: 'Agree',
      decline: 'I decline consent at this time and understand I will not be able to use this site after the initial period',
    },
    acceptButton: {
      saving: 'Saving...',
      continue: 'Continue',
    },
  },
  errors: {
    loadingPatientConsentInfo: 'There was an error loading the patient consent information.',
    unexpectedErrorTryAgain: 'There was an unexpected error. Please try again.',
    noPatientConsentInfoFound: 'No patient consent information found.',
    noHipaaConsentInfoFound: 'No HIPAA consent information found.',
  },
};

export const patientConsentTranslationsES: PatientConsentTranslations = {
  loading: 'Cargando...',
  patientConsent: 'Consentimiento del paciente',
  declineTerms: {
    dischargedWithin30Days: 'Tendrá otra oportunidad de aceptar o rechazar estos términos a los 30 días después del alta.',
    notDischargedWithin30Days: 'No podrá usar Reflections sin aceptar estos términos.',
    popup: {
      title: '¿Rechazar términos?',
      cancel: 'Cancelar',
      decline: 'Rechazar',
    },
  },
  acceptConsent: {
    acceptButton: {
      saving: 'Guardando...',
      next: 'Siguiente',
    },
  },
  acceptHipaa: {
    authority: {
      parent: 'Padre/Madre',
      legalGuardian: 'Tutor legal',
      other: 'Otro (describa la autoridad)',
      otherInput: {
        placeHolder: 'Describa la autoridad...',
      },
    },
    options: {
      agree: 'Aceptar',
      decline: 'Rechazo el consentimiento en este momento y entiendo que no podré usar este sitio después del período inicial',
    },
    acceptButton: {
      saving: 'Guardando...',
      continue: 'Continuar',
    },
  },
  errors: {
    loadingPatientConsentInfo: 'Hubo un error al cargar la información de consentimiento del paciente.',
    unexpectedErrorTryAgain: 'Ocurrió un error inesperado. Por favor, inténtelo de nuevo.',
    noPatientConsentInfoFound: 'No se encontró información de consentimiento del paciente.',
    noHipaaConsentInfoFound: 'No se encontró información de consentimiento HIPAA.',
  },
};
